<template>
  <div>
    <q-select
      v-model="motivosSelecionados"
      :options="listaMotivos"
      class="input-mobile"
      dense
      outlined
      multiple
      use-chips
      option-label="label"
      option-value="value"
      behavior="menu"
      label="Selecione os Motivos"
      label-color="grey-6"
    >
      <template v-slot:selected-item="scope">
        <q-chip
          removable
          dense
          @remove="scope.removeAtIndex(scope.index)"
          :tabindex="scope.tabindex"
          color="primary"
          text-color="white"
          class="q-ma-xs"
        >
          {{ scope.opt.label }}
        </q-chip>
      </template>
    </q-select>

    <q-input
      v-if="outrosSelecionado"
      v-model="motivoOutros"
      :input-style="{ maxHeight: '150px' }"
      outlined
      type="textarea"
      label="Descreva o motivo"
      dense
      class="q-mt-sm input-mobile"
    />
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";

export default {
  emits: ["enviarMotivos"],
  props: ["model", "resetar"],
  setup(props, { emit }) {
    const motivosSelecionados = ref(props.model || []);
    const motivoOutros = ref("");

    const listaMotivos = ref([
      {
        label: "CABO ELÉTRICO/PLUG TOMADA",
        value: "CABO ELÉTRICO/PLUG TOMADA",
      },
      {
        label: "CABO ELÉTRICO/PLUG ATRACADOR",
        value: "CABO ELÉTRICO/PLUG ATRACADOR",
      },
      { label: "PROBLEMA MECÂNICO", value: "PROBLEMA MECÂNICO" },
      { label: "TRAVAMENTO", value: "TRAVAMENTO" },
      { label: "QUEIMA", value: "QUEIMA" },
      { label: "QUEDA", value: "QUEDA" },
      { label: "PROBLEMA ELÉTRICO", value: "PROBLEMA ELÉTRICO" },
      { label: "OUTROS", value: "OUTROS" },
    ]);

    const outrosSelecionado = computed(() => {
      return motivosSelecionados.value.some((m) => m.value === "OUTROS");
    });

    watch(
      () => props.resetar,
      () => {
        motivosSelecionados.value = [];
        motivoOutros.value = "";
      }
    );

    watch(
      () => motivosSelecionados.value,
      () => {
        if (!outrosSelecionado.value) {
          motivoOutros.value = "";
        }
        enviarMotivos();
      },
      { deep: true }
    );

    watch(
      () => motivoOutros.value,
      () => {
        if (outrosSelecionado.value) {
          enviarMotivos();
        }
      }
    );

    const enviarMotivos = () => {
      let motivosFiltrados = motivosSelecionados.value.filter(
        (m) => m.value !== "OUTROS"
      );

      let motivosConcatenados = motivosFiltrados.map((m) => m.value).join(", ");

      if (outrosSelecionado.value && motivoOutros.value.trim()) {
        if (motivosConcatenados) {
          motivosConcatenados += ", " + motivoOutros.value.trim();
        } else {
          motivosConcatenados = motivoOutros.value.trim();
        }
      }

      emit("enviarMotivos", motivosConcatenados);
    };

    return {
      motivosSelecionados,
      listaMotivos,
      motivoOutros,
      outrosSelecionado,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .input-mobile {
    font-size: 12px;
  }
}
</style>
